// extracted by mini-css-extract-plugin
export default {"percentageBar":"Percentage_percentageBar__ksexW","bar-animation":"Percentage_bar-animation__dAviO"};